import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { useAppSelector } from "app/redux/hooks"
import { FiltroListarProfissionais, ProfissionalComissoes } from "app/types/comissoes/Profissionais"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { adicionarProfissionais } from "app/use-cases/orcamento/comissoes/profissionais"
import globalMU from "globalMU"
import React, { useState } from "react"
import { AbaProfissionais, DadosAbaProfissionais } from "./AbaProfissionais"

export type AbaProfissionaisContainerProps = {
    mostrarBotaoCancelar: boolean;
    onAtivarIncluirProfissional: (permitir: boolean) => void;
    onAlteradoDadosProfissionais: (dados: DadosAbaProfissionais) => void;
}

export const AbaProfissionaisContainer = (props: AbaProfissionaisContainerProps & DadosAbaProfissionais) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [profissionais, setProfissionais] = useState<Partial<PagedMessageResponse<ProfissionalComissoes>>>(props.listaPesquisa)
    const [filtroProfissionais, setFiltroProfissionais] = useState<FiltroListarProfissionais>(props.abaProfissionaisFormulario)

    const onPesquisarProfissionais = async (filtros: FiltroListarProfissionais) => {
        try {
            globalMU.blockUI();
            setFiltroProfissionais({ ...filtros, IdentificadorOrcamento: orcamento.IdentificadorOrcamento });
            const clientesPesquisados = await microuniversoApi.Orcamento.listarProfissionais({
                Codigo: filtros?.Codigo,
                IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
                Nome: filtros?.Nome,
                NumeroPagina: filtros?.NumeroPagina ?? 1,
                TamanhoPagina: filtros?.TamanhoPagina ?? 20
            });
            !("HasErrors" in clientesPesquisados) && setProfissionais(clientesPesquisados)
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onEnviarProfissionais = async (profissionais: ProfissionalComissoes[], listaProfissionaisTipo: {[codigo: number]: string}) => {
        const profissionaisSelecionadosComExterno = profissionais.map(p => ({...p, Externo: listaProfissionaisTipo[p.Codigo] == "Externo" ? true : false }))

        if (profissionais.length == 0) {
            globalMU.showErrorMessage("Selecione o(s) profissional(is) a ser(em) adicionado(s).")
            return
        }
        if (profissionais.some(p => (listaProfissionaisTipo[p.Codigo]?.length??"") == 0)) {
            globalMU.showErrorMessage("Informe o tipo de todos os profissionais selecionados.")
            return
        }

        try {
            globalMU.blockUI();
            const resultado = await adicionarProfissionais(profissionaisSelecionadosComExterno)

            if (!("HasErrors" in resultado)) {
                props.onAtivarIncluirProfissional(true)
                globalMU.showSuccessMessage("Profissional(is) adicionado(s) com sucesso")
            }

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }

    }

    return (
        <AbaProfissionais
            abaProfissionaisFormulario={filtroProfissionais}
            listaPesquisa={profissionais}
            profissionaisSelecionados={props.profissionaisSelecionados}
            listaProfissionaisTipo={props.listaProfissionaisTipo}
            mostrarBotaoCancelar={props.mostrarBotaoCancelar}
            colorBackgroundSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
            colorTextoSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
            somenteLeitura={orcamento.SomenteLeitura}
            onAlteradoDadosProfissionais={props.onAlteradoDadosProfissionais}
            onOk={onEnviarProfissionais}
            onPesquisar={onPesquisarProfissionais}
            onCancelar={() => props.onAtivarIncluirProfissional(true)}
        />
    )
}
